export default "__VITE_ASSET__DFEPdfJq__"